import Model, {toModel, toMoment, toProp} from "./Model";
import Document from "./Document";

/**
 *
 * @class PatientDocument
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.8] app/src/model/PatientDocument.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

class PatientDocument extends Model {
  constructor(modelData) {
    super()

    this.patientDocumentId = toProp()

    /** @type Document */
    this.document = toModel(Document)

    /** @type Number */
    this.timesOpened = toProp()

    /** @type Number */
    this.relatedTestQuestionsRight = toProp()

    /** @type Number */
    this.relatedTestQuestionsWrong = toProp()

    /** @type Number */
    this.timesSent = toProp()

    /** @type Boolean */
    this.favoured = toProp()

    /** @type Boolean */
    this.recommended = toProp()

    /** @type Boolean */
    this.topicSelected = toProp()

    /** @type moment */
    this.openDate = toMoment()

    this.buildModel(modelData)
  }
}

export default PatientDocument